import api from "@/interceptors";
import { IApiPromise } from "@/interfaces/responseData";
import { Checklist, Org } from "../apiRoutes/routes";
import {
  IWizardPageQuestion,
  IWizardQuestion,
  IWizardQuestionStore,
  IWizardQuestionsResponse,
  IWizardServicesValue,
  IWizardTypeValue,
} from "@/interfaces/wizard";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import dayjs from "dayjs";

export const generateQuestionDataPage = (
  pageQuestion: IWizardPageQuestion[],
  questions: IWizardQuestion[],
) => {
  pageQuestion.map((question) => {
    const questionValue = questions?.find(
      (i) => i.questionTypeId === question.typeId,
    );

    if (questionValue) {
      const typeValue =
        questionValue.types && questionValue.types[0]
          ? questionValue.types[0].typeValues
          : ([] as IWizardTypeValue[]);
      const valueSelected =
        questionValue.values && questionValue.values.length ? 1 : 0;

      valueSelected === 1 && (question.valueSelected = valueSelected);
      question.QuestionOptions = convertDropdownTypeValue(typeValue);
      question.values = questionValue.values;
    }
  });

  return pageQuestion;
};

export const generateWebServiceQuestionData = (pageQuestion, questions) => {
  questions?.forEach((item) => {
    const question = pageQuestion.find((q) => {
      return q.questionTypeId === item.questionTypeId;
    });

    if (question) {
      question.childData = item.types[0].typeValues;
    }
  });

  return pageQuestion;
};

export const generateQuestionDataSitesPage = (pageQuestion, questions) => {
  questions.forEach((item) => {
    const question = pageQuestion.find((q) => {
      return q.typeId === item.typeId;
    });
    if (question) {
      question.QuestionOptions = item.typeValues;
    }
  });
  return pageQuestion;
};

const convertDropdownTypeValue = (
  types: IWizardTypeValue[] = [],
): IDropDownData[] => {
  return types.map((i) => {
    const obj: IDropDownData = {
      id: i.id,
      name: i.name || "",
    };

    if (i.revenueBandFrom || i.revenueBandTo) {
      const currency = i.currencyId ? ` (${i.currencyId})` : "";
      const from = i.revenueBandFrom ?? 0;
      const to = i.revenueBandTo
        ? ` - ${i.revenueBandTo.toLocaleString()}`
        : "+";

      obj.name = `${from.toLocaleString()}${to}${currency}`;
    }

    return obj;
  });
};

export const initialDataToStore = (
  res: IWizardQuestionsResponse,
  currentOrg,
): IWizardQuestionStore => {
  const result = {} as IWizardQuestionStore;
  if (res.idOrg) result[res.idOrg] = {} as any;

  if (res.idOrg && res.sections && res.sections.length) {
    res.sections.forEach((item) => {
      if (item.sectionId) result[res.idOrg][item.sectionId] = item.questions;
    });
  }
  if (result[currentOrg].org) {
    result[currentOrg].org.forEach((question: any) => {
      question.values.sort((a: any, b: any) => Number(a.id) - Number(b.id));
    });
  }
  if (
    result[currentOrg].brands &&
    result[currentOrg].brands[0].values.length == 0
  ) {
    result[currentOrg].brands[0].values.push({
      id: "",
      brandName: "",
      domainRegistrarId: null,
      domainRegistrar: null,
      startDate: new Date(),
      description: null,
      notes: null,
      endDate: null,
      showAccordion: false,
      isArchived: false,
    });
  }
  if (
    result[currentOrg].domains &&
    result[currentOrg].domains[0].values.length == 0
  ) {
    result[currentOrg].domains[0].values.push({
      id: "",
      domainName: "",
      domainRegistrarId: null,
      domainRegistrar: null,
      startDate: new Date(),
      description: null,
      notes: null,
      endDate: null,
      showAccordion: false,
      isEdit: true,
      isArchived: false,
    });
  }
  if (result[currentOrg].sites[0].values.length == 0) {
    result[currentOrg].sites[0].values.push({
      name: "",
      typeId: "",
      legalTypeId: "",
      address1: "",
      address2: "",
      address3: null,
      townCity: "",
      postcode: null,
      countryId: "",
      startDate: "",
      details: "",
      notes: "",
      // showMoreDetail: false,
      // isCollapse: false,
      siteAttributes: [],
      isArchived: false,
    });
  }
  if (result[currentOrg].teams[0].values.length == 0) {
    result[currentOrg].teams[0].values.push({
      teamTypeId: "",
      isArchived: false,
      notes: "",
      details: "",
    });
  }
  result[currentOrg].webservices.forEach((e: any, index) => {
    e.values.forEach((el: any) => {
      if (index == 0) {
        el.isWebsite = 1;
      } else {
        el.isWebsite = 0;
      }
    });
  });

  const groupValues = formatServiceSection(
    result[currentOrg].services[0].values,
    result[currentOrg].services[0],
  );

  result[currentOrg].services[0].formatData = groupValues;
  return result;
};

export const formatServiceSection = (serviceData: any, service) => {
  // format data in service section
  const serviceTypeTypeValues = service.types[0].typeValues;
  const serviceSubTypeTypeValues = service.types[1].typeValues;
  const serviceDataGroupBySubType = serviceData.map((item, index) => {
    const serviceType = serviceTypeTypeValues.find(
      (i) => i.id === item.serviceTypeId,
    );
    const serviceTypeOptions = serviceTypeTypeValues.filter(
      (i) => i.serviceSubTypeId === serviceType?.serviceSubTypeId,
    );
    const serviceSubType = serviceSubTypeTypeValues.find(
      (i) => i.id === serviceType?.serviceSubTypeId,
    );
    const title = serviceSubType?.name || "";
    let parentTitle = "";
    if (serviceSubType?.parentId) {
      const parentServiceSubType = serviceSubTypeTypeValues.find(
        (i) => i.id === serviceSubType.parentId,
      );
      parentTitle = `${parentServiceSubType?.name || ""}`;
    }
    return {
      ...item,
      isArchived: item.isArchived || false,
      serviceSubTypeId: serviceSubType?.id || "",
      indexUpdate: index,
      title,
      parentTitle,
      serviceTypeOptions,
      initServiceType: serviceType,
      orgServicesName: item.orgServices[0]?.name || null,
      orgServicesId: item.orgServices[0]?.id || null,
      orgServicesProviderEmailCommerical:
        item.orgServices[0]?.providerEmailCommerical || null,
      orgServicesProviderEmailSupport:
        item.orgServices[0]?.providerEmailSupport || null,
      orgServicesProviderPhone: item.orgServices[0]?.providerPhone || null,
      orgServicesDescription: item.orgServices[0]?.description || null,
      timeUpdated: `${dayjs().unix()}${index}`,
    };
  });
  // Group service with the same serviceTypeId.
  const groupValues = Object.values(
    serviceDataGroupBySubType.reduce((acc, curr) => {
      if (!acc[curr.serviceSubTypeId || ""])
        acc[curr.serviceSubTypeId || ""] = [];
      acc[curr.serviceSubTypeId || ""].push(curr);
      return acc;
    }, {}),
  ) as IWizardServicesValue[][];
  return groupValues;
};

export const getUpdatedVal = (oldVal, newVal, keysToCheck) => {
  const updatedVal = {};
  for (const key in newVal) {
    if (newVal[key] !== oldVal[key] && keysToCheck.includes(key)) {
      updatedVal[key] = newVal[key];
    }
  }
  return updatedVal;
};

export const getWizardQuestion = async (
  param?: string,
): IApiPromise<IWizardQuestionsResponse> =>
  api.get(`${Org.getOrgSetup}?includeTypes=${true}${param ? `&${param}` : ""}`);

export const haldleSetupOrganisationOrg = (params: any): IApiPromise<any> =>
  api.post(Org.postOrgSetup, params);
export const haldleSetupOrganisationGoals = (params: any): IApiPromise<any> =>
  api.post(Org.postGoalSetup, params);

export const hanldleSetupDomains = (params: any): IApiPromise<any> =>
  api.post(Org.postDomainSetup, params);

export const hanldleSetupBrands = (params: any): IApiPromise<any> =>
  api.post(Org.postBrandSetup, params);

export const hanldleSetupServices = (params: any): IApiPromise<any> =>
  api.post(Org.postServicesSetup, params);

export const hanldleSetupTeams = (params: any): IApiPromise<any> =>
  api.post(Org.postTeamsSetup, params);

export const hanldleSetupMisc = (params: any): IApiPromise<any> =>
  api.post(Org.postMiscSetup, params);

export const hanldleSetupSite = (params: any): IApiPromise<any> =>
  api.post(Org.postSiteSetup, params);
export const hanldleSetupWebFacing = (params: any): IApiPromise<any> =>
  api.post(Org.postWebFacingSetup, params);

export const getChecklistIncidents =
  async (): IApiPromise<IWizardQuestionsResponse> =>
    api.get(`${Org.getOrgIncidents}`);

export const putChecklistIncidents = async (
  params: any,
): IApiPromise<IWizardQuestionsResponse> =>
  api.put(Org.putOrgIncidents.replace(":incidentId", params.id), params.option);
export const postChecklistIncident = async (
  params: any,
): IApiPromise<IWizardQuestionsResponse> =>
  api.post(Org.postOrgIncident, params);

export const getChecklistIncidentType =
  async (): IApiPromise<IWizardQuestionsResponse> =>
    api.get(Org.getOrgIncidentType);

export const getChecklistImpactLevel =
  async (): IApiPromise<IWizardQuestionsResponse> =>
    api.get(Checklist.getChecklistImpactLevel);

export const getChecklistCost =
  async (): IApiPromise<IWizardQuestionsResponse> =>
    api.get(Checklist.getChecklistCost);
